import type { Components, Theme } from "@mui/material";

export const tabTheme: Components<Theme>["MuiTab"] = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      ...theme.typography.h3,
      borderBottom: `2px solid transparent`,
      boxSizing: "border-box",
      color: theme.palette.text.secondary,
      minWidth: "80px",
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      "&.Mui-selected": {
        color: theme.palette.text.main,
      },
      "&:hover": {
        borderColor: theme.palette.custom.borderHover,
        color: theme.palette.text.main,
      },
    }),
  },
};
